// src/hooks/useForceLogout.js
import { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../config/Config';
import { auth } from '../config/Config';

const VERSION_KEY = 'appVersion';

export function useForceLogout() {
  useEffect(() => {
    // Listen to the version document in real-time
    const unsubscribe = onSnapshot(
      doc(firestore, 'appConfig', 'version'),
      (snapshot) => {
        if (!snapshot.exists()) return;

        const serverVersion = snapshot.data().number;
        const localVersion  = localStorage.getItem(VERSION_KEY);

        if (localVersion === null) {
          // First time — just save the version, don't logout
          localStorage.setItem(VERSION_KEY, String(serverVersion));
          return;
        }

        if (String(serverVersion) !== localVersion) {
          // Version mismatch → force logout
          localStorage.setItem(VERSION_KEY, String(serverVersion));
          auth.signOut().then(() => {
            localStorage.clear();
            window.location.href = '/login';
          });
        }
      },
      (error) => {
        console.error('Version listener error:', error);
      }
    );

    // Cleanup listener when component unmounts
    return () => unsubscribe();
  }, []);
}